module.exports = __webpack_public_path__ + "static/media/lazyaz_app5_preview.9c0a60b3.jpg";